query onboardingDocuments($companyId: ID!) {
  onboardingDocuments(companyId: $companyId) {
    type
    file {
      id
      url
      name
    }
  }
}
